/**
 *  @class
 *  @function GiftWithPurchase
 */
class GiftWithPurchase {
	constructor() {
		this.container = document.getElementById('Cart-Drawer')
		this.handleCartItemAdded = this.handleCartItemAdded.bind(this)
		this.handleCartChange = this.handleCartChange.bind(this)

		this.minimumSpend = `${theme.settings.gwp_minimum_spend}` * 100
		this.minimumSpendConverted = Math.round(
			parseInt(this.minimumSpend, 10) * (Shopify.currency.rate || 1)
		)
		this.gwpProduct = `${theme.settings.gwp_product_handle}`
		this.gwpProductVariantID = `${theme.settings.gwp_product_variant_id}`

		this.additionalProductFormText = `<form method="post" action="/cart/add" id="product-form-template--16072540225696__main-product" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
            <input type="hidden" name="form_type" value="product">
            <input type="hidden" name="utf8" value="✓">
            <input type="hidden" name="id" value="${this.gwpProductVariantID}">
            <div class="product-add-to-cart-container">
                <div class="form-notification error" style="display:none;"></div>
                <div class="add_to_cart_holder">
                    <button type="submit" name="add" id="AddToCart" class="single-add-to-cart-button button ">
                        <span class="single-add-to-cart-button--text">Add to cart</span>
                    </button>
                </div>
            </div>
        </form>`
		this.additionalProductFormHTML = ''

		this.discountHidden = true
	}

	handleCartItemAdded() {
		const getCartConfig = {
			method: 'GET',
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				Accept: 'application/javascript',
			},
		}

		fetch(`${theme.routes.cart_url}`, getCartConfig)
			.then((cartResponse) => cartResponse.json())
			.then((cartResponseData) => {
				let cartItems = cartResponseData.items
				let gwpEligible = cartItems.filter(function (item) {
					return item.properties._GWP != 'false'
				})
				let gwpEligibleSum = gwpEligible.reduce((accumulator, item) => {
					return accumulator + item.final_line_price
				}, 0)

				if (gwpEligibleSum >= this.minimumSpendConverted) {
					let hasGWP = cartItems.find(
						(item) => item.variant_id == this.gwpProductVariantID
					)

					if (!hasGWP) {
						const addGWPConfig = {
							method: 'POST',
							headers: {
								'X-Requested-With': 'XMLHttpRequest',
								Accept: 'application/javascript',
							},
						}

						let stringToHTML = function (str) {
							let parser = new DOMParser()
							let doc = parser.parseFromString(str, 'text/html')
							return doc.body.firstChild
						}
						this.additionalProductFormHTML = stringToHTML(
							this.additionalProductFormText
						)
						let gwpFormData = new FormData(this.additionalProductFormHTML)

						gwpFormData.append(
							'sections',
							this.getSectionsToRender().map((section) => section.section)
						)

						gwpFormData.append('sections_url', window.location.pathname)
						addGWPConfig.body = gwpFormData

						fetch(`${theme.routes.cart_add_url}`, addGWPConfig)
							.then((gwpAddResponse) => gwpAddResponse.json())
							.then((gwpAddResponse) => {
								if (gwpAddResponse.status) {
									this.handleErrorMessage(gwpAddResponse.description)
									return
								}
								this.renderContents(gwpAddResponse)
							})
							.catch((gwpAddError) => {
								console.error('error:', gwpAddError)
							})
					}
				}
			})
			.catch((cartResponseError) => {
				console.error('error:', cartResponseError)
			})
	}

	getSectionsToRender() {
		return [
			{
				id: 'Cart',
				section: 'main-cart',
				selector: '.thb-cart-form',
			},
			{
				id: 'Cart-Drawer',
				section: 'cart-drawer',
				selector: '.cart-drawer',
			},
			{
				id: 'cart-drawer-toggle',
				section: 'cart-bubble',
				selector: '.thb-item-count',
			},
		]
	}

	getSectionsToRenderChange() {
		return [
			{
				id: 'Cart-Drawer',
				section: 'cart-drawer',
				selector: '.cart-drawer',
			},
			{
				id: 'cart-drawer-toggle',
				section: 'cart-bubble',
				selector: '.thb-item-count',
			},
		]
	}

	renderContents(parsedState) {
		this.getSectionsToRender().forEach((section) => {
			if (!document.getElementById(section.id)) {
				return
			}
			const elementToReplace =
				document.getElementById(section.id).querySelector(section.selector) ||
				document.getElementById(section.id)
			elementToReplace.innerHTML = this.getSectionInnerHTML(
				parsedState.sections[section.section],
				section.selector
			)

			if (typeof CartDrawer !== 'undefined') {
				new CartDrawer()
			}
			if (typeof Cart !== 'undefined') {
				new Cart().renderContents(parsedState)
			}
		})

		let product_drawer = document.getElementById('Product-Drawer')
		if (product_drawer && product_drawer.contains(this)) {
			product_drawer
				.querySelector('.product-quick-images--container')
				.classList.remove('active')
			document.body.classList.remove('open-quick-view')

			if (window.innerWidth < 1069) {
				product_drawer.classList.remove('active')
				if (document.getElementById('Cart-Drawer')) {
					document.getElementById('Cart-Drawer').classList.add('active')
					document.body.classList.add('open-cart')
					document
						.getElementById('Cart-Drawer')
						.querySelector('.product-recommendations--full')
						.classList.add('active')
					dispatchCustomEvent('cart-drawer:open')
				}
			} else {
				product_drawer
					.querySelector('.product-quick-images--container')
					.addEventListener('transitionend', function () {
						product_drawer.classList.remove('active')

						if (document.getElementById('Cart-Drawer')) {
							document.getElementById('Cart-Drawer').classList.add('active')
							document.body.classList.add('open-cart')
							document
								.getElementById('Cart-Drawer')
								.querySelector('.product-recommendations--full')
								.classList.add('active')
							dispatchCustomEvent('cart-drawer:open')
						}
					})
			}

			if (!document.getElementById('Cart-Drawer')) {
				document.body.classList.remove('open-cc')
			}
		} else if (document.getElementById('Cart-Drawer')) {
			document.body.classList.add('open-cc')
			document.body.classList.add('open-cart')
			document.getElementById('Cart-Drawer').classList.add('active')
			dispatchCustomEvent('cart-drawer:open')
		}
	}

	handleCartChange(event) {
		if (event.type == 'cart:discount-applied') {
			this.discountHidden = false
		}

		if (event.type == 'cart:discount-removed') {
			this.discountHidden = true
			this.handleCartItemAdded()
		}

		if (event.type == 'line-item:change:end' && this.discountHidden == true) {
			let cart = event.detail.cart
			let removedVariantID = cart?.items_removed[0]?.variant_id

			if (
				this.gwpProductVariantID != removedVariantID &&
				this.discountHidden == true
			) {
				let cartItems = cart.items
				let gwpEligible = cartItems.filter(function (item) {
					return item.properties._GWP != 'false'
				})
				let gwpEligibleSum = gwpEligible.reduce((accumulator, item) => {
					return accumulator + item.final_line_price
				}, 0)

				if (gwpEligibleSum >= this.minimumSpendConverted) {
					let hasGWP = cartItems.find(
						(item) => item.variant_id == this.gwpProductVariantID
					)

					// check if GWP is already in cart
					if (!hasGWP) {
						// first, add GWP to cart
						const configGWPAdd = {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
								Accept: 'application/json',
							},
							body: JSON.stringify({
								id: this.gwpProductVariantID,
								quantity: 1,
							}),
						}
						fetch(`${theme.routes.cart_add_url}`, configGWPAdd)
							.then(() => {
								// then, get cart with GWP and re-render mini cart
								const configAdd = {
									method: 'POST',
									headers: {
										'Content-Type': 'application/json',
										Accept: 'application/json',
									},
									body: JSON.stringify({
										id: this.gwpProductVariantID,
										quantity: 1,
										sections: this.getSectionsToRenderChange().map(
											(section) => section.section
										),
										sections_url: window.location.pathname,
									}),
								}

								fetch(`${theme.routes.cart_change_url}`, configAdd)
									.then((cartResponse) => cartResponse.json())
									.then((cartResponse) => {
										this.getSectionsToRenderChange().forEach((section) => {
											const elementToReplace =
												document
													.getElementById(section.id)
													.querySelector(section.selector) ||
												document.getElementById(section.id)

											elementToReplace.innerHTML = this.getSectionInnerHTML(
												cartResponse.sections[section.section],
												section.selector
											)
										})
									})
									.catch((error) => {
										console.log('error:', error)
									})
							})
							.catch((error) => {
								console.log('error:', error)
							})
					}
				} else {
					// remove GWP
					const configRemove = {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							Accept: 'application/json',
						},
						body: JSON.stringify({
							id: this.gwpProductVariantID,
							quantity: 0,
							sections: this.getSectionsToRenderChange().map(
								(section) => section.section
							),
							sections_url: window.location.pathname,
						}),
					}
					fetch(`${theme.routes.cart_change_url}`, configRemove)
						.then((cartResponse) => cartResponse.json())
						.then((cartResponse) => {
							this.getSectionsToRenderChange().forEach((section) => {
								const elementToReplace =
									document
										.getElementById(section.id)
										.querySelector(section.selector) ||
									document.getElementById(section.id)

								elementToReplace.innerHTML = this.getSectionInnerHTML(
									cartResponse.sections[section.section],
									section.selector
								)
							})
						})
						.catch((error) => {
							console.log('error:', error)
						})
				}
			}
		} else if (this.discountHidden == false) {
			let cart = event.detail.newcart

			let cartItems = cart.lines.nodes
			let gwpEligible = cartItems.filter(function (item) {
				return !item.merchandise.product.tags.includes('dropship')
			})

			let pricesArray = gwpEligible.map((item) => item.cost.totalAmount.amount)
			let numbersArray = pricesArray.map(Number)
			let gwpEligibleSum = numbersArray.reduce((accumulator, number) => {
				return accumulator + number * 100
			}, 0)

			let gwpProductInCart = this.container.querySelector(
				`.product-cart-item-info[gwp-variant-id="${this.gwpProductVariantID}"]`
			)

			if (gwpProductInCart && gwpEligibleSum < this.minimumSpendConverted) {
				const configRemove = {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/json',
					},
					body: JSON.stringify({
						id: this.gwpProductVariantID,
						quantity: 0,
						sections: this.getSectionsToRenderChange().map(
							(section) => section.section
						),
						sections_url: window.location.pathname,
					}),
				}
				fetch(`${theme.routes.cart_change_url}`, configRemove)
					.then((cartResponse) => cartResponse.json())
					.then((cartResponse) => {
						this.getSectionsToRenderChange().forEach((section) => {
							const elementToReplace =
								document
									.getElementById(section.id)
									.querySelector(section.selector) ||
								document.getElementById(section.id)

							elementToReplace.innerHTML = this.getSectionInnerHTML(
								cartResponse.sections[section.section],
								section.selector
							)
						})
					})
					.catch((error) => {
						console.log('error:', error)
					})
			}

			if (!gwpProductInCart && gwpEligibleSum >= this.minimumSpendConverted) {
				const configGWPAdd = {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/json',
					},
					body: JSON.stringify({
						id: this.gwpProductVariantID,
						quantity: 1,
					}),
				}
				fetch(`${theme.routes.cart_add_url}`, configGWPAdd)
					.then(() => {
						// then, get cart with GWP and re-render mini cart
						const configAdd = {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
								Accept: 'application/json',
							},
							body: JSON.stringify({
								id: this.gwpProductVariantID,
								quantity: 1,
								sections: this.getSectionsToRenderChange().map(
									(section) => section.section
								),
								sections_url: window.location.pathname,
							}),
						}

						fetch(`${theme.routes.cart_change_url}`, configAdd)
							.then((cartResponse) => cartResponse.json())
							.then((cartResponse) => {
								this.getSectionsToRenderChange().forEach((section) => {
									const elementToReplace =
										document
											.getElementById(section.id)
											.querySelector(section.selector) ||
										document.getElementById(section.id)

									elementToReplace.innerHTML = this.getSectionInnerHTML(
										cartResponse.sections[section.section],
										section.selector
									)
								})
							})
							.catch((error) => {
								console.log('error:', error)
							})
					})
					.catch((error) => {
						console.log('error:', error)
					})
			}
		}
	}

	handleDiscountApplied(event) {
		let cart = event.detail.newcart

		let cartItems = cart.lines.nodes
		let gwpEligible = cartItems.filter(function (item) {
			return !item.merchandise.product.tags.includes('dropship')
		})

		let pricesArray = gwpEligible.map((item) => item.cost.totalAmount.amount)
		let numbersArray = pricesArray.map(Number)
		let gwpEligibleSum = numbersArray.reduce((accumulator, number) => {
			return accumulator + number * 100
		}, 0)

		let gwpProductInCart = this.container.querySelector(
			`.product-cart-item-info[gwp-variant-id="${this.gwpProductVariantID}"]`
		)

		if (gwpProductInCart && gwpEligibleSum < this.minimumSpendConverted) {
			const configRemove = {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/json',
				},
				body: JSON.stringify({
					id: this.gwpProductVariantID,
					quantity: 0,
					sections: this.getSectionsToRenderChange().map(
						(section) => section.section
					),
					sections_url: window.location.pathname,
				}),
			}
			fetch(`${theme.routes.cart_change_url}`, configRemove)
				.then((cartResponse) => cartResponse.json())
				.then((cartResponse) => {
					this.getSectionsToRenderChange().forEach((section) => {
						const elementToReplace =
							document
								.getElementById(section.id)
								.querySelector(section.selector) ||
							document.getElementById(section.id)

						elementToReplace.innerHTML = this.getSectionInnerHTML(
							cartResponse.sections[section.section],
							section.selector
						)
					})
				})
				.catch((error) => {
					console.log('error:', error)
				})
		}
	}

	getSectionInnerHTML(html, selector = '.shopify-section') {
		return new DOMParser()
			.parseFromString(html, 'text/html')
			.querySelector(selector).innerHTML
	}

	addEventListeners() {
		document.addEventListener('cart:item-added', this.handleCartItemAdded)
		document.addEventListener('line-item:change:end', this.handleCartChange)
		document.addEventListener('cart:discount-applied', this.handleCartChange)
		document.addEventListener('cart:discount-removed', this.handleCartChange)
	}
}

const giftWithPurchase = new GiftWithPurchase()
giftWithPurchase.addEventListeners()
